import classesBK from './betKurs.module.css'
import classes from './textPages.module.css'
import BetKursButtons from '../components/BetKursButtons'

const BetSistemi = () => {
  return (
    <div className={classesBK.mainContainer}>
      <div className={classesBK.sidebar}>
        <BetKursButtons type={'betsystem'} />
      </div>
      <div className={classesBK.content}>
        <div className={classesBK.headerContainer}>
          <h1>BET SISTEMI</h1>
        </div>

        <p>
          <strong>
            Dobro došli u svet logike, matematike i beskonačnih kombinacija.
          </strong>
        </p>
        <p>
          Sistemi predstavljaju sastavni deo{' '}
          <strong>statističke matematike</strong>, tačnije oblasti{' '}
          <strong>kombinatorike</strong> – jedne od ključnih naučnih disciplina
          kada je reč o svim igrama zasnovanim na brojkama. Bilo da govorimo o{' '}
          <strong>sportskom klađenju</strong>, <strong>kazino igrama</strong>,{' '}
          <strong>lotou</strong> ili bilo kojoj igri koja uključuje verovatnoću
          – <strong>sistemi su osnova ozbiljnog pristupa</strong>.
        </p>
        <p>
          Kako je naša platforma fokusirana na sportske teme i rezultate,
          sekcija <strong>„SISTEMI“</strong> u okviru korisničkog menija
          namenjena je upravo predstavljanju i obradi{' '}
          <strong>
            različitih kombinatoričkih sistema vezanih za prognoziranje
            sportskih ishoda
          </strong>
          .
        </p>
        <h3>Šta možete da očekujete?</h3>
        <p>
          Sekcija će se <strong>kontinuirano nadograđivati</strong> novim
          sistemima, različitih formi i složenosti. Za vas to znači{' '}
          <strong>konstantno obogaćivanje sadržaja</strong> i sve više alata za
          pametno i analitičko klađenje.
        </p>
        <p>U okviru prezentacija moći ćete da upoznate:</p>
        <ul>
          <li>različite vrste sistema i njihove primene</li>
          <li>garancije koje pojedini sistemi pružaju</li>
          <li>uslove i pravila primene</li>
          <li>procenat zahtevan za pogođene parove</li>
          <li>primer kvota i mogućih ishoda</li>
          <span>
            kao i druge korisne informacije koje sistem čine efikasnim i
            razumljivim.
          </span>
        </ul>
        <h3>Sistemi nisu samo sistemski tiketi.</h3>
        <p>
          Većina igrača kada čuje reč „sistem“ pomisli na{' '}
          <strong>sistemski tiket</strong> – kao što su pun sistem ili pun
          sistem u sistemu, što je standardna ponuda kod većine priređivača
          igara. Međutim, sistemsko klađenje je{' '}
          <strong>mnogo širi pojam</strong>.
        </p>
        <p>
          U okviru našeg sadržaja kroz kontinuiranu dopunu sistema u sadržaju
          menija, upoznavaćete:
        </p>
        <ul>
          <strong>
            <li>skraćene sisteme</li>
          </strong>
          <strong>
            <li>procentne sisteme</li>
          </strong>
          <strong>
            <li>jednotrećinske i dvotrećinske sisteme</li>
          </strong>
          <strong>
            <li>višeuslovne sisteme</li>
          </strong>
          <span>
            kao i brojne <strong>originalne BETKO sisteme</strong>, među kojima
            su:
          </span>
          <strong>
            <li>Puni grupisani BETKO sistemi</li>
          </strong>
          <strong>
            <li>Skraćeni grupisani BETKO sistemi</li>
          </strong>
          <strong>
            <li>BETKO sistemi u sistemu</li>
          </strong>
          <strong>
            <li>
              Specijalni sistemi sa originalnim nazivima, npr. Atomska bomba i
              drugi.
            </li>
          </strong>
        </ul>
        <h3>Važna napomena:</h3>
        <p>
          <strong>- Ni jedan sistem ne daje garanciju dobitka.</strong>
          <br />- Sistemi služe da vam{' '}
          <strong>pomognu da kontrolišete igru</strong>, ali klađenje i dalje
          ostaje igra neizvesnosti.
        </p>
        <p>
          Ova sekcija je osmišljena za sve vas koji želite da u klađenju
          pronađete <strong>više znanja</strong>,{' '}
          <strong>matematike i logike</strong>, a manje oslanjanja na sreću.
          Dobro došli u svet sistema !
        </p>
      </div>
    </div>
  )
}

export default BetSistemi
